import React, { useState, useContext, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import indFlag from "../../assets/img/india-flag-icon.png";
import * as Sentry from "@sentry/react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import "../flag.css";

import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import {
  Box,
  ClickAwayListener,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import { REACT_APP_PROD_URL, SITE_KEY_CAPTCHA } from "../../services/configs";
import { CoinContext } from "../../contexts/CoinContext";
import loaderGif from "../../assets/img/loader.gif";
import ReCAPTCHA from "react-google-recaptcha";
import fetcher from "../../api/swr_fetcher";
import { useDispatch } from "react-redux";

let code = "+91";

export default function ForgotPassword() {
  const classes = useStyles();
  let history = useHistory();
  const dispatch = useDispatch();

  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [repassword, setRepassword] = useState(null);
  const [reset, setReset] = useState(false);
  const [emailOtp, setEmailOtp] = useState(null);
  const [phoneOtp, setPhoneOtp] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [showOTP, setShowOTP] = useState({ email: false, phone: false });

  const [showPassword, setShowPassword] = useState(false);

  const [isValid, setIsValid] = useState({ boo: true, message: "" });

  const [loading, setLoading] = useState(false);

  const [errorFields, setErrorFields] = useState({
    email: false,
    password: false,
    repass: false,
    eotp: false,
    potp: false,
  });

  const [counter, setCounter] = useState(120);
  const [startTimer, setStartTimer] = useState(false);

  const [captcha, setCaptcha] = useState("");
  const reRef = useRef();

  const { handleClickAlert } = useContext(CoinContext);

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    if (isValid.boo) {
      history.push(`/login`);
    } else {
      setReset(false);
    }
  };

  function submitForm() {
    if (reset) {
      if (
        password &&
        !errorFields.password &&
        !errorFields.repass &&
        emailOtp
      ) {
        if (showOTP.phone) {
          if (!phoneOtp) {
            setErrorFields({
              ...errorFields,
              potp: phoneOtp ? false : true,
            });
            return;
          }
        }
        setLoading(true);
        // console.log("Resetting password");
        fetcher(`/account/reset-password/finish`, {
          method: "POST",
          body: {
            email: email,
            password: password,
            mobileOtp: phoneOtp ? phoneOtp : "",
            emailOtp: emailOtp,
            clientKey: captcha,
          },
        })
          .then((res) => {
            setErrorFields({
              email: false,
              password: false,
              repass: false,
              eotp: false,
              potp: false,
            });
            setLoading(false);
            handleDialogOpen();

            setEmail(null);
            setPassword(null);
            setRepassword(null);
            setEmailOtp(null);
            setPhoneOtp(null);
            setLoading(false);
            handleDialogOpen();

            // console.log(res);
          })
          .catch((err) => {
            if (err.status == 400) {
              alert("Invalid OTP! Please try again.");
            }
            setLoading(false);
            setReset(false);
            setIsValid({
              boo: false,
              message: "",
            });
            console.error(err);
            // console.error(err);
          });
      } else {
        setErrorFields({
          ...errorFields,
          email: false,
          password: password ? errorFields.password : true,
          repass: repassword ? errorFields.repass : true,
          eotp: emailOtp ? false : true,
        });
        setLoading(false);
      }
    } else {
      if (email && !errorFields.email) {
        // console.log("Getting OTP");
        initForgot();
      } else {
        setErrorFields({
          ...errorFields,
          email: email ? errorFields.email : true,
        });
        setLoading(false);
      }
    }
  }

  async function initForgot() {
    if (email) {
      const captchaToken = await reRef.current.executeAsync();
      setCaptcha(captchaToken);
      reRef.current.reset();

      setLoading(true);
      fetcher(`/account/reset-password/init`, {
        method: "POST",
        body: {
          email: email,
          clientKey: captchaToken,
        },
      })
        .then((data) => {
          // console.log(data);
          if (!data.status) {
            setStartTimer(true);
            setIsValid({ boo: true, message: "" });
            setReset(true);
            setShowOTP({
              email: data.email,
              phone: data.phone,
            });
            setErrorFields({
              ...errorFields,
              email: false,
            });
            setLoading(false);
            handleClickAlert("success", "OTP sent");
          }
        })
        .catch((err) => {
          setReset(false);
          setLoading(false);
          setIsValid({
            boo: false,
            message: "Please enter registered email ID.",
          });
          console.error(err);
          // console.error(err);
        });
    } else {
      setErrorFields({
        ...errorFields,
        email: true,
      });
    }
  }

  function resendOtp() {
    if (email) {
      initForgot();
    } else {
      handleClickAlert("error", "OTP resend failed");
    }
  }
  function handleLogout() {
    // console.log("Logging out");
    dispatch({ type: "SET_TOKEN", payload: null });
    dispatch({ type: "SET_TOKEN_STATUS", payload: null });
    dispatch({ type: "SET_LOGIN_ID", payload: null });

    window.fcWidget.user.clear();
    history.push(`/login`);

    // window.location.reload();
  }
  const padTime = (time) => {
    return String(time).length === 1 ? `0${time}` : `${time}`;
  };

  const format = (time) => {
    // Convert seconds into minutes and take the whole part
    const minutes = Math.floor(time / 60);

    // Get the seconds left after converting minutes
    const seconds = time % 60;

    //Return combined values as string in format mm:ss
    return `${minutes}:${padTime(seconds)}`;
  };

  useEffect(() => {
    let timer;
    if (counter > 0 && startTimer) {
      timer = setTimeout(() => setCounter((c) => c - 1), 1000);
    } else if (counter === 0) {
      setStartTimer(false);
      setCounter(120);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [counter, startTimer]);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        {reset ? (
          <>
            <Typography variant="h4" className={classes.title}>
              Reset Password
            </Typography>
            {/* <p style={{ fontWeight: "bold", color: "#868786" }}>
              Your new password must include atleast 1 uppercase letter, 1
              lowercase letter and 1 special character.
            </p> */}
            <div className={classes.form}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <p
                    style={{
                      color: "#868786",
                      marginBottom: "2px",
                      fontWeight: "bold",
                      marginTop: "30px",
                    }}
                  >
                    NEW PASSWORD
                  </p>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    onChange={(e) => {
                      let val = e.target.value.replace(/\s/g, "");
                      if (val.length < 6 || val.length > 20) {
                        setErrorFields({
                          ...errorFields,
                          password: true,
                          repass: val !== repassword,
                        });
                      } else {
                        setErrorFields({
                          ...errorFields,
                          password: false,
                          repass: val !== repassword,
                        });
                      }
                      setPassword(val);
                    }}
                    value={password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            // onMouseDown={() => setShowPassword(true)}
                            // onMouseUp={() => setShowPassword(false)}
                            onClick={() => {
                              setShowPassword(!showPassword);
                            }}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                    }}
                    error={errorFields.password}
                    helperText={
                      errorFields.password
                        ? "Password length should be between 6 to 20 characters"
                        : null
                    }
                    onKeyUp={(event) => {
                      if (
                        event.key === "Enter" ||
                        event.key === "NumpadEnter"
                      ) {
                        submitForm();
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <p
                    style={{
                      color: "#868786",
                      marginBottom: "2px",
                      fontWeight: "bold",
                    }}
                  >
                    CONFIRM NEW PASSWORD
                  </p>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    onChange={(e) => {
                      let val = e.target.value.replace(/\s/g, "");
                      if (val === password) {
                        setErrorFields({
                          ...errorFields,
                          repass: false,
                        });
                      } else {
                        setErrorFields({
                          ...errorFields,
                          repass: true,
                        });
                      }
                      setRepassword(val);
                    }}
                    value={repassword}
                    onPaste={(e) => {
                      e.preventDefault();
                    }}
                    error={errorFields.repass}
                    helperText={
                      errorFields.repass ? "Passwords do not match" : null
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <p
                    style={{
                      color: "#868786",
                      marginBottom: "2px",
                      fontWeight: "bold",
                    }}
                  >
                    Email OTP
                  </p>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    id="ecode"
                    type="number"
                    name="ecode"
                    onChange={(e) => setEmailOtp(e.target.value)}
                    error={errorFields.eotp}
                    helperText={
                      errorFields.eotp
                        ? "Please enter the otp received on email"
                        : null
                    }
                    onKeyUp={(event) => {
                      if (
                        event.key === "Enter" ||
                        event.key === "NumpadEnter"
                      ) {
                        submitForm();
                      }
                    }}
                  />
                </Grid>
                {showOTP.phone ? (
                  <Grid item xs={12}>
                    <p
                      style={{
                        color: "#868786",
                        marginBottom: "2px",
                        fontWeight: "bold",
                      }}
                    >
                      Phone OTP
                    </p>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      id="pcode"
                      type="number"
                      name="pcode"
                      onChange={(e) => setPhoneOtp(e.target.value)}
                      error={errorFields.potp}
                      helperText={
                        errorFields.potp
                          ? "Please enter the otp received on phone"
                          : null
                      }
                      onKeyUp={(event) => {
                        if (
                          event.key === "Enter" ||
                          event.key === "NumpadEnter"
                        ) {
                          submitForm();
                        }
                      }}
                    />
                  </Grid>
                ) : null}
              </Grid>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: "15px",
                }}
              >
                {counter === 0 || counter === 120 ? (
                  <div onClick={resendOtp} className={classes.link}>
                    Resend OTP
                  </div>
                ) : (
                  <div>Resend OTP in {format(counter)}</div>
                )}
              </div>

              {isValid.boo ? null : (
                <p style={{ color: "red", margin: 0, marginTop: "10px" }}>
                  {isValid.message}
                </p>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={submitForm}
              >
                Change Password
              </Button>
            </div>
          </>
        ) : (
          <>
            <Typography variant="h4" className={classes.title}>
              Change password
            </Typography>
            <p className={classes.phone_p} style={{ fontWeight: 700 }}>
              Enter your registered email id. Codes will be sent to your email.
            </p>

            <div className={classes.form}>
              <p className={classes.phone_p} style={{ fontWeight: "bold" }}>
                EMAIL
              </p>
              <ClickAwayListener
                onClickAway={() => {
                  if (email) {
                    let re = /\S+@\S+\.\S+/;
                    if (re.test(email)) {
                      setErrorFields({
                        ...errorFields,
                        email: false,
                      });
                    } else {
                      setErrorFields({
                        ...errorFields,
                        email: true,
                      });
                    }
                  }
                }}
              >
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="email"
                  id="email"
                  onChange={(e) => {
                    let val = e.target.value.replace(/\s/g, "");
                    setEmail(val);
                  }}
                  value={email}
                  error={errorFields.email}
                  helperText={errorFields.email ? "Invalid email" : null}
                  onKeyUp={(event) => {
                    if (event.key === "Enter" || event.key === "NumpadEnter") {
                      submitForm();
                    }
                  }}
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                    inputProps: { maxLength: 50 },
                  }}
                />
              </ClickAwayListener>

              {isValid.boo ? null : (
                <p style={{ color: "red", margin: 0, marginTop: "10px" }}>
                  {isValid.message}
                </p>
              )}

              <Button
                style={{
                  width: "150px",
                  height: "45px",
                }}
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={submitForm}
                // disabled={errorFields.email}
              >
                GET OTP
              </Button>
            </div>
          </>
        )}

        <Dialog
          open={openDialog}
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent style={{ textAlign: "center", marginTop: "20px" }}>
            {isValid.boo ? (
              <CheckCircleOutlineIcon
                style={{
                  fontSize: "60px",
                  color: "#3AC4AB",
                  marginBottom: "20px",
                }}
              />
            ) : (
              <CancelOutlinedIcon
                style={{
                  fontSize: "60px",
                  color: "red",
                  marginBottom: "20px",
                }}
              />
            )}
            <DialogContentText id="alert-dialog-description">
              {isValid.boo
                ? "Your Password has been reset successfully"
                : "Request failed. Please try again."}
            </DialogContentText>
          </DialogContent>
          {isValid.boo ? (
            <DialogActions>
              <Button
                variant="contained"
                style={{
                  marginRight: "16px",
                  marginBottom: "16px",
                  color: "white",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  handleLogout();
                }}
                color="primary"
                autoFocus
              >
                Login
              </Button>
            </DialogActions>
          ) : null}
        </Dialog>
      </div>
      <Backdrop className={classes.backdrop} open={loading}>
        {/* <CircularProgress color="primary" /> */}
        <img src={loaderGif} alt="loading..." />
      </Backdrop>
      <ReCAPTCHA sitekey={SITE_KEY_CAPTCHA} size="invisible" ref={reRef} />
    </Container>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(20),
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontSize: "2.5rem",
    alignItems: "left",
    fontWeight: 900,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    alignItems: "center",
  },
  phone_p: {
    color: "#868786",
    marginTop: "15px",
    marginBottom: "10px",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    color: "#fff",
    fontWeight: "600",
  },
  link: {
    fontWeight: "bold",
    color: "#3AC4AB",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));
